// Global handlers for auth redirects that may land on the wrong route.
//
// 1. Password recovery: Supabase emails link back to the app's Site URL with
//    a hash like `#access_token=...&type=recovery`. If that lands on `/` (or
//    any route other than `/reset-password`), forward the hash to the reset
//    page so the user can actually set a new password.
//
// 2. OAuth token fragment: if an OAuth broker drops the user on the landing
//    page with `#access_token=...`, forward it into `/app` after Supabase has
//    picked it up.

import { supabase } from "@/integrations/supabase/client";

export function installAuthRedirectHandlers(): void {
  if (typeof window === "undefined") return;

  const forwardRecoveryFromHash = () => {
    const hash = window.location.hash || "";
    if (!hash.includes("type=recovery")) return false;
    if (window.location.pathname === "/reset-password") return false;
    // Preserve the full hash so /reset-password can read the token.
    window.location.replace("/reset-password" + hash);
    return true;
  };

  // Run once on load.
  if (forwardRecoveryFromHash()) return;

  // Also react to Supabase's own recovery event (fires after it parses hash).
  supabase.auth.onAuthStateChange((event) => {
    if (event === "PASSWORD_RECOVERY" && window.location.pathname !== "/reset-password") {
      window.location.replace("/reset-password");
    }
  });
}
